import { RadarService } from './radar.service';

import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

export const MODULES = [CommonModule, TranslateModule];
@Component({
  selector: 'app-radar-legend',
  templateUrl: './radar.legend.component.html',
  styleUrls: ['./radar.component.scss'],
  imports: [...MODULES],
})
export class RadarLegendComponent {
  legendType = input<string>();
  public radarService = inject(RadarService);
}
